export const AboutProfileIcon = () => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="24" cy="24" r="24" fill="#9C8AC1" fillOpacity="0.16" />
    <path
      d="M17.5 12C16.0413 12 14.6424 12.5795 13.6109 13.6109C12.5795 14.6424 12 16.0413 12 17.5V29.5C12 30.9587 12.5795 32.3576 13.6109 33.3891C14.6424 34.4205 16.0413 35 17.5 35H25.554C25.452 34.2187 25.6109 33.4257 26.006 32.744L26.436 32H17.5C16.12 32 15 30.88 15 29.5V18H32V20.388C32.944 20.014 33.98 19.888 35 20.04V17.5C35 16.0413 34.4205 14.6424 33.3891 13.6109C32.3576 12.5795 30.9587 12 29.5 12H17.5ZM28.542 27.372C28.1373 25.9372 28.3006 24.4016 28.998 23.084L26.208 20.292C26.0202 20.1045 25.7657 19.9993 25.5003 19.9994C25.2349 19.9996 24.9805 20.1052 24.793 20.293C24.6055 20.4808 24.5003 20.7353 24.5004 21.0007C24.5006 21.2661 24.6062 21.5205 24.794 21.708L28.086 25L24.794 28.292C24.6062 28.4795 24.5006 28.7339 24.5004 28.9993C24.5003 29.2647 24.6055 29.5192 24.793 29.707C24.9805 29.8948 25.2349 30.0004 25.5003 30.0006C25.7657 30.0007 26.0202 29.8955 26.208 29.708L28.542 27.372V27.372ZM22.206 20.292C22.2991 20.3849 22.373 20.4952 22.4234 20.6167C22.4738 20.7382 22.4998 20.8685 22.4998 21C22.4998 21.1315 22.4738 21.2618 22.4234 21.3833C22.373 21.5048 22.2991 21.6151 22.206 21.708L18.914 25L22.206 28.292C22.299 28.3848 22.3728 28.4951 22.4231 28.6165C22.4735 28.7378 22.4995 28.8679 22.4996 28.9993C22.4996 29.1307 22.4739 29.2608 22.4237 29.3822C22.3735 29.5037 22.2998 29.614 22.207 29.707C22.1142 29.8 22.0039 29.8738 21.8825 29.9241C21.7612 29.9745 21.6311 30.0005 21.4997 30.0006C21.3683 30.0006 21.2382 29.9749 21.1168 29.9247C20.9953 29.8745 20.885 29.8008 20.792 29.708L16.792 25.708C16.6989 25.6151 16.625 25.5048 16.5746 25.3833C16.5242 25.2618 16.4982 25.1315 16.4982 25C16.4982 24.8685 16.5242 24.7382 16.5746 24.6167C16.625 24.4952 16.6989 24.3849 16.792 24.292L20.792 20.292C20.9795 20.1045 21.2338 19.9992 21.499 19.9992C21.7642 19.9992 22.0185 20.1045 22.206 20.292V20.292ZM34.846 22.042L33.046 25.162C32.9554 25.3071 32.895 25.469 32.8684 25.6379C32.8417 25.8069 32.8494 25.9795 32.8908 26.1454C32.9323 26.3113 33.0068 26.4672 33.1098 26.6038C33.2128 26.7403 33.3423 26.8547 33.4904 26.9401C33.6386 27.0256 33.8025 27.0803 33.9722 27.101C34.142 27.1218 34.3142 27.1082 34.4786 27.0609C34.643 27.0137 34.7962 26.9338 34.9291 26.8261C35.062 26.7184 35.1718 26.5851 35.252 26.434L37.052 23.316C37.546 23.8933 37.8566 24.6047 37.9442 25.3594C38.0317 26.1141 37.8923 26.8778 37.5436 27.5528C37.1949 28.2278 36.6529 28.7835 35.9867 29.1489C35.3206 29.5143 34.5606 29.6727 33.804 29.604L30.496 35.334C30.3937 35.519 30.2555 35.6818 30.0896 35.8129C29.9236 35.9439 29.7332 36.0406 29.5295 36.0972C29.3258 36.1539 29.1129 36.1694 28.9031 36.1429C28.6933 36.1164 28.4909 36.0483 28.3078 35.9427C28.1246 35.8371 27.9643 35.696 27.8362 35.5278C27.7081 35.3596 27.6148 35.1675 27.5618 34.9628C27.5088 34.7582 27.497 34.545 27.5273 34.3357C27.5575 34.1264 27.6292 33.9253 27.738 33.744L31.04 28.024C30.596 27.4043 30.3476 26.666 30.3267 25.904C30.3058 25.142 30.5133 24.3912 30.9226 23.7481C31.3319 23.105 31.9242 22.5991 32.6234 22.2954C33.3226 21.9917 34.0966 21.9042 34.846 22.044V22.042Z"
      fill="#7E00FD"
    />
  </svg>
);

export const SocialLinksIcon = () => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="24" cy="24" r="24" fill="#9C8AC1" fillOpacity="0.16" />
    <path
      d="M25.5443 22.4565C24.7252 21.6377 23.6144 21.1777 22.4563 21.1777C21.2981 21.1777 20.1874 21.6377 19.3683 22.4565L16.2793 25.5444C15.4602 26.3636 15 27.4745 15 28.6329C15 29.7914 15.4602 30.9023 16.2793 31.7215C17.0984 32.5406 18.2094 33.0007 19.3678 33.0007C20.5262 33.0007 21.6372 32.5406 22.4563 31.7215L24.0003 30.1774"
      stroke="#7E00FD"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22.457 25.5443C23.2761 26.3631 24.3869 26.823 25.545 26.823C26.7032 26.823 27.8139 26.3631 28.633 25.5443L31.722 22.4563C32.5412 21.6372 33.0013 20.5262 33.0013 19.3678C33.0013 18.2094 32.5412 17.0984 31.722 16.2793C30.9029 15.4602 29.7919 15 28.6335 15C27.4751 15 26.3642 15.4602 25.545 16.2793L24.001 17.8233"
      stroke="#7E00FD"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const BasedInIcon = () => (
  <svg
    width="32"
    height="24"
    viewBox="0 0 32 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 0H45.6V1.8469H0V0ZM0 3.69375H45.6V5.54065H0V3.69375ZM0 7.3828H45.6V9.23435H0V7.3828ZM0 11.0766H45.6V12.9234H0V11.0766ZM0 14.7703H45.6V16.6172H0V14.7703ZM0 18.4594H45.6V20.3063H0V18.4594ZM0 22.1531H45.6V24H0V22.1531Z"
      fill="#BD3D44"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 1.84766H45.6V3.69451H0V1.84766ZM0 5.54136H45.6V7.38356H0V5.54136ZM0 9.23046H45.6V11.0773H0V9.23046ZM0 12.9242H45.6V14.7711H0V12.9242ZM0 16.618H45.6V18.4648H0V16.618ZM0 20.307H45.6V22.1539H0V20.307Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 0H18.239V12.9234H0V0Z"
      fill="#192F5D"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.51877 0.552734L1.68752 1.06358H2.22192L1.79062 1.37768L1.95472 1.89328L1.51877 1.57453L1.08752 1.88858L1.25157 1.37768L0.815674 1.06358H1.35942L1.51877 0.552734ZM4.56097 0.552734L4.72502 1.06358H5.26407L4.82812 1.37768L4.99222 1.89328L4.56097 1.57453L4.12502 1.88858L4.28907 1.37768L3.85782 1.06358H4.39222L4.56097 0.552734ZM7.59847 0.552734L7.76722 1.06363H8.29692L7.86567 1.37773L8.02967 1.89333L7.59377 1.57458L7.16252 1.88863L7.32657 1.37773L6.89062 1.06363H7.42972L7.59847 0.552734ZM10.6407 0.552734L10.8047 1.06363H11.3438L10.9078 1.37773L11.0766 1.89333L10.6406 1.57458L10.2047 1.88863L10.3735 1.37773L9.93752 1.06363H10.4719L10.6407 0.552734ZM13.6782 0.552734L13.8469 1.06363H14.3813L13.95 1.37773L14.1141 1.89333L13.6781 1.57458L13.2469 1.88863L13.411 1.37773L12.9797 1.06363H13.5141L13.6782 0.552734ZM16.7203 0.552734L16.8844 1.06363H17.4235L16.9875 1.37773L17.1563 1.89333L16.7203 1.57458L16.2844 1.88863L16.4531 1.37773L16.0172 1.06363H16.5563L16.7203 0.552734ZM3.04222 1.84638L3.20627 2.35738H3.74532L3.30937 2.67138L3.46877 3.18238L3.04687 2.86828L2.61097 3.18233L2.76562 2.67143L2.34377 2.35733H2.87817L3.04222 1.84638ZM6.07972 1.84638L6.24847 2.35738H6.78282L6.34687 2.67138L6.51567 3.18238L6.07967 2.86828L5.64377 3.18233L5.81252 2.67143L5.37657 2.35733H5.91562L6.07972 1.84638ZM9.12192 1.84638L9.28592 2.35738H9.82502L9.38907 2.67138L9.55312 3.18238L9.12187 2.86828L8.68597 3.18233L8.85002 2.67148L8.41877 2.35738H8.95317L9.12192 1.84638ZM12.1594 1.84638L12.3282 2.35738H12.8625L12.4266 2.67138L12.5953 3.18238L12.1594 2.86828L11.7281 3.18233L11.8922 2.67143L11.4563 2.35733H12L12.1594 1.84638ZM15.2016 1.84638L15.3656 2.35738H15.9047L15.4688 2.67138L15.6328 3.18238L15.2016 2.86828L14.7656 3.18233L14.9297 2.67143L14.4985 2.35733H15.0328L15.2016 1.84638ZM1.51877 3.13558L1.68752 3.65588H2.22192L1.79062 3.96993L1.95472 4.48088L1.51877 4.16213L1.08752 4.48088L1.25157 3.96523L0.815674 3.65123H1.35942L1.51877 3.13558ZM4.56097 3.13558L4.72502 3.65108H5.26407L4.82812 3.96513L4.99222 4.47613L4.56097 4.15733L4.12502 4.47608L4.28907 3.96048L3.85782 3.64643H4.39222L4.56097 3.13558ZM7.59847 3.13558L7.76722 3.65118H8.29692L7.86567 3.96523L8.02967 4.47623L7.59377 4.15743L7.16252 4.47618L7.32657 3.96058L6.89062 3.64653H7.42972L7.59847 3.13558ZM10.6407 3.13558L10.8047 3.65118H11.3438L10.9078 3.96523L11.0766 4.47623L10.6406 4.15743L10.2047 4.47618L10.3735 3.96058L9.93752 3.64653H10.4719L10.6407 3.13558ZM13.6782 3.13558L13.8469 3.65118H14.3813L13.95 3.96518L14.1141 4.47618L13.6781 4.15738L13.2469 4.47613L13.411 3.96053L12.9797 3.64648H13.5141L13.6782 3.13558ZM16.7203 3.13558L16.8844 3.65118H17.4235L16.9875 3.96523L17.1563 4.47623L16.7203 4.15743L16.2844 4.47618L16.4531 3.96058L16.0172 3.64653H16.5563L16.7203 3.13558ZM3.04222 4.42928L3.20627 4.94023H3.74532L3.30937 5.25423L3.47347 5.76988L3.04222 5.45113L2.60627 5.76518L2.77032 5.25428L2.33907 4.94023H2.87352L3.04222 4.42928ZM6.07972 4.42928L6.24847 4.94023H6.78282L6.34687 5.25423L6.51567 5.76988L6.07967 5.45113L5.64377 5.76518L5.81252 5.25428L5.37657 4.94023H5.91562L6.07972 4.42928ZM9.12192 4.42928L9.28592 4.94023H9.82502L9.38907 5.25423L9.55312 5.76988L9.12187 5.45113L8.68597 5.76518L8.85002 5.25428L8.41877 4.94023H8.95317L9.12192 4.42928ZM12.1594 4.42928L12.3282 4.94023H12.8625L12.4313 5.25423L12.5953 5.76988L12.1594 5.45113L11.7281 5.76518L11.8922 5.25428L11.4563 4.94023H12L12.1594 4.42928ZM15.2016 4.42928L15.3656 4.94023H15.9047L15.4688 5.25423L15.6328 5.76988L15.2016 5.45113L14.7656 5.76518L14.9297 5.25428L14.4985 4.94023H15.0328L15.2016 4.42928ZM1.51877 5.72303L1.68752 6.23398H2.22192L1.79062 6.54798L1.95472 7.06363L1.51877 6.74488L1.08752 7.05893L1.25157 6.54803L0.815674 6.23398H1.35942L1.51877 5.72303ZM4.56097 5.72303L4.72502 6.23398H5.26407L4.82812 6.54798L4.99222 7.05898L4.56097 6.74488L4.12502 7.05893L4.28907 6.54803L3.85782 6.23398H4.39222L4.56097 5.72303ZM7.59847 5.72303L7.76722 6.23398H8.29692L7.86567 6.54798L8.02967 7.06363L7.59377 6.74488L7.16252 7.05893L7.32657 6.54803L6.89062 6.23398H7.42972L7.59847 5.72303ZM10.6407 5.72303L10.8047 6.23398H11.3438L10.9078 6.54798L11.0766 7.06363L10.6406 6.74488L10.2047 7.05893L10.3735 6.54803L9.93752 6.23398H10.4719L10.6407 5.72303ZM13.6782 5.72303L13.8469 6.23398H14.3813L13.95 6.54798L14.1141 7.06363L13.6781 6.74488L13.2469 7.05893L13.411 6.54803L12.9797 6.23398H13.5141L13.6782 5.72303ZM16.7203 5.72303L16.8844 6.23398H17.4235L16.9875 6.54798L17.1563 7.06363L16.7203 6.74488L16.2844 7.05893L16.4531 6.54803L16.0172 6.23398H16.5563L16.7203 5.72303ZM3.04222 7.01678L3.20627 7.52773H3.74532L3.30937 7.84173L3.47347 8.35273L3.04222 8.03398L2.60627 8.35273L2.77032 7.83708L2.33907 7.52303H2.87352L3.04222 7.01678ZM6.07972 7.01678L6.24847 7.52773H6.78282L6.34687 7.84173L6.51567 8.35273L6.07967 8.03398L5.64377 8.35273L5.81252 7.83708L5.37657 7.52303H5.91562L6.07972 7.01678ZM9.12192 7.01678L9.28592 7.52773H9.82502L9.38907 7.84173L9.55312 8.35273L9.12187 8.03398L8.68597 8.35273L8.85002 7.83708L8.41877 7.52303H8.95317L9.12192 7.01678ZM12.1594 7.01678L12.3282 7.52773H12.8625L12.4313 7.84173L12.5953 8.35273L12.1594 8.03398L11.7281 8.35273L11.8922 7.83708L11.4563 7.52303H12L12.1594 7.01678ZM15.2016 7.01678L15.3656 7.52773H15.9047L15.4688 7.84173L15.6328 8.35273L15.2016 8.03398L14.7656 8.35273L14.9297 7.83708L14.4985 7.52303H15.0328L15.2016 7.01678ZM1.51877 8.30583L1.68752 8.82148H2.22192L1.79062 9.13548L1.95472 9.64178L1.51877 9.32773L1.08752 9.64173L1.25157 9.13083L0.815674 8.81678H1.35942L1.51877 8.30583ZM4.56097 8.30583L4.72502 8.82148H5.26407L4.82812 9.13548L4.99692 9.64178L4.56092 9.32773L4.12502 9.64173L4.29377 9.13083L3.85782 8.81678H4.39222L4.56097 8.30583ZM7.59847 8.30583L7.76722 8.82148H8.29692L7.86567 9.13548L8.02967 9.64178L7.59377 9.32773L7.16252 9.64173L7.32657 9.13083L6.89062 8.81678H7.42972L7.59847 8.30583ZM10.6407 8.30583L10.8047 8.82148H11.3438L10.9078 9.13548L11.0766 9.64178L10.6406 9.32773L10.2047 9.64173L10.3735 9.13083L9.93752 8.81678H10.4719L10.6407 8.30583ZM13.6782 8.30583L13.8469 8.82148H14.3813L13.95 9.13548L14.1141 9.64178L13.6781 9.32773L13.2469 9.64173L13.411 9.13083L12.9797 8.81678H13.5141L13.6782 8.30583ZM16.7203 8.30583L16.8844 8.82148H17.4235L16.9875 9.13548L17.1563 9.64178L16.7203 9.32773L16.2844 9.64173L16.4531 9.13083L16.0172 8.81678H16.5563L16.7203 8.30583ZM3.04222 9.59958L3.20627 10.1105H3.74532L3.30937 10.4246L3.47347 10.9402L3.04222 10.6215L2.60627 10.9355L2.77032 10.4246L2.33907 10.1105H2.87352L3.04222 9.59958ZM6.07972 9.59958L6.24847 10.1105H6.78282L6.34687 10.4246L6.51567 10.9402L6.07967 10.6215L5.64377 10.9355L5.81252 10.4246L5.37657 10.1105H5.91562L6.07972 9.59958ZM9.12192 9.59958L9.28592 10.1105H9.82502L9.38907 10.4246L9.55312 10.9402L9.12187 10.6215L8.68597 10.9355L8.85002 10.4246L8.41877 10.1105H8.95317L9.12192 9.59958ZM12.1594 9.59958L12.3282 10.1105H12.8625L12.4313 10.4246L12.5953 10.9402L12.1594 10.6215L11.7281 10.9355L11.8922 10.4246L11.4563 10.1105H12L12.1594 9.59958ZM15.2016 9.59958L15.3656 10.1105H15.9047L15.4688 10.4246L15.6328 10.9402L15.2016 10.6215L14.7656 10.9355L14.9297 10.4246L14.4985 10.1105H15.0328L15.2016 9.59958ZM1.51877 10.8933L1.68752 11.4043H2.22192L1.79062 11.7183L1.95472 12.2293L1.51877 11.9152L1.08752 12.2292L1.25157 11.7136L0.815674 11.3996H1.35942L1.51877 10.8933ZM4.56097 10.8933L4.72502 11.4043H5.26407L4.82812 11.7183L4.99692 12.2293L4.56092 11.9152L4.12502 12.2292L4.29377 11.7136L3.85782 11.3996H4.39222L4.56097 10.8933ZM7.59847 10.8933L7.76722 11.4043H8.29692L7.87502 11.7183L8.03907 12.2293L7.60312 11.9152L7.17187 12.2292L7.33597 11.7136L6.90002 11.3996H7.43907L7.59847 10.8933ZM10.6407 10.8933L10.8047 11.4043H11.3438L10.9078 11.7183L11.0766 12.2293L10.6406 11.9152L10.2047 12.2292L10.3735 11.7136L9.93752 11.3996H10.4719L10.6407 10.8933ZM13.6782 10.8933L13.8469 11.4043H14.3813L13.95 11.7183L14.1141 12.2293L13.6781 11.9152L13.2469 12.2292L13.411 11.7136L12.9797 11.3996H13.5141L13.6782 10.8933ZM16.7203 10.8933L16.8844 11.4043H17.4235L16.9875 11.7183L17.1563 12.2293L16.7203 11.9152L16.2844 12.2292L16.4531 11.7136L16.0172 11.3996H16.5563L16.7203 10.8933Z"
      fill="white"
    />
  </svg>
);

export const FacebookIcon = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.5 11.0586C0.5 16.2789 4.29138 20.6197 9.25 21.5V13.9164H6.625V11H9.25V8.66638C9.25 6.04138 10.9414 4.58362 13.3336 4.58362C14.0914 4.58362 14.9086 4.7 15.6664 4.81638V7.5H14.325C13.0414 7.5 12.75 8.14137 12.75 8.95862V11H15.55L15.0836 13.9164H12.75V21.5C17.7086 20.6197 21.5 16.2798 21.5 11.0586C21.5 5.25125 16.775 0.5 11 0.5C5.225 0.5 0.5 5.25125 0.5 11.0586Z"
      fill="#292E73"
      fillOpacity="0.82"
    />
  </svg>
);

export const TwitterIcon = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"
      fill="#292E73"
      fillOpacity="0.82"
    />
  </svg>
);

export const LinkedinIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 1.4325C0 0.64125 0.6575 0 1.46875 0H18.5312C19.3425 0 20 0.64125 20 1.4325V18.5675C20 19.3587 19.3425 20 18.5312 20H1.46875C0.6575 20 0 19.3587 0 18.5675V1.4325ZM6.17875 16.7425V7.71125H3.1775V16.7425H6.17875ZM4.67875 6.4775C5.725 6.4775 6.37625 5.785 6.37625 4.9175C6.3575 4.03125 5.72625 3.3575 4.69875 3.3575C3.67125 3.3575 3 4.0325 3 4.9175C3 5.785 3.65125 6.4775 4.65875 6.4775H4.67875ZM10.8138 16.7425V11.6988C10.8138 11.4288 10.8337 11.1587 10.9137 10.9662C11.13 10.4275 11.6238 9.86875 12.4538 9.86875C13.54 9.86875 13.9738 10.6962 13.9738 11.9113V16.7425H16.975V11.5625C16.975 8.7875 15.495 7.4975 13.52 7.4975C11.9275 7.4975 11.2137 8.3725 10.8138 8.98875V9.02H10.7938C10.8004 9.00957 10.8071 8.99915 10.8138 8.98875V7.71125H7.81375C7.85125 8.55875 7.81375 16.7425 7.81375 16.7425H10.8138Z"
      fill="#292E73"
      fillOpacity="0.82"
    />
  </svg>
);

export const WebIcon = () => (
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.5 0C4.7103 0 0 4.7103 0 10.5C0 16.2897 4.7103 21 10.5 21C16.2897 21 21 16.2897 21 10.5C21 4.7103 16.2897 0 10.5 0ZM18.8275 9.45H15.9253C15.7958 7.15181 15.1529 4.91186 14.0437 2.89485C15.3292 3.4955 16.4418 4.41147 17.2782 5.55756C18.1146 6.70365 18.6476 8.04264 18.8275 9.45ZM11.0565 2.12835C12.1432 3.56055 13.6048 6.09735 13.8148 9.45H7.3815C7.52745 6.7242 8.4252 4.1706 9.95505 2.1273C10.1356 2.1168 10.3162 2.1 10.5 2.1C10.6879 2.1 10.8717 2.1168 11.0565 2.12835ZM7.0224 2.86335C5.9892 4.8489 5.3928 7.1001 5.2815 9.45H2.17245C2.35386 8.03023 2.89446 6.68021 3.74314 5.52764C4.59181 4.37507 5.72048 3.45806 7.0224 2.86335ZM2.17245 11.55H5.29515C5.43795 14.0479 5.9934 16.2519 6.92895 18.0915C5.65025 17.4887 4.54411 16.5734 3.71276 15.43C2.8814 14.2867 2.35165 12.9522 2.17245 11.55ZM9.9225 18.8716C8.45145 17.0887 7.5831 14.5908 7.39305 11.55H13.8117C13.5933 14.4616 12.6388 17.0058 11.0785 18.8706C10.8874 18.8832 10.6963 18.9 10.5 18.9C10.3047 18.9 10.1146 18.8832 9.9225 18.8716ZM14.134 18.061C15.1368 16.1773 15.749 13.965 15.9096 11.55H18.8265C18.6493 12.9405 18.1272 14.2646 17.3076 15.4018C16.488 16.539 15.3971 17.4531 14.134 18.061Z"
      fill="#292E73"
      fillOpacity="0.82"
    />
  </svg>
);

export const ExperienceIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.677734 7.99935C0.677734 3.94926 3.96098 0.666016 8.01107 0.666016C12.0612 0.666016 15.3444 3.94926 15.3444 7.99935V8.66602H13.6205L8.67774 13.6088V15.3327H8.01107C3.96098 15.3327 0.677734 12.0494 0.677734 7.99935ZM9.34126 9.33307V3.99974H8.00793V7.99974H4.00793V9.33307H9.34126Z"
      fill="#FF5722"
    />
  </svg>
);

export const JobPreferenceIcon = () => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="24" cy="24" r="24" fill="#9C8AC1" fillOpacity="0.16" />
    <path
      d="M25.6252 33.0742L32.7002 26.0117L35.3502 28.6617L28.2752 35.7242L25.6252 33.0742ZM29.6252 22.9117L25.7502 19.0617C25.6024 18.9169 25.4339 18.7948 25.2502 18.6992L23.8502 13.3367C23.7604 13.0247 23.5528 12.7597 23.2713 12.5979C22.9897 12.4361 22.6562 12.3901 22.3414 12.4696C22.0265 12.5491 21.7549 12.748 21.5839 13.0241C21.413 13.3002 21.3561 13.6319 21.4252 13.9492L22.7502 19.0367L19.8377 12.9867C19.5502 12.3617 18.8002 12.1242 18.1752 12.3867C17.5502 12.6867 17.2877 13.4367 17.5877 14.0617L19.7002 18.4867L15.4877 14.3117C15.0002 13.8242 14.2002 13.8242 13.7127 14.3117C13.2252 14.8117 13.2377 15.5992 13.7252 16.0867L18.3752 20.7117L17.5002 21.0492L16.1502 21.5867L13.7627 23.2367C13.7627 23.2367 12.7502 24.5492 12.6627 25.1117C12.5627 25.6742 13.6502 28.4992 13.6502 28.4992H13.6627C13.8627 28.9242 14.2877 29.2242 14.7877 29.2242C15.1193 29.2242 15.4372 29.0925 15.6716 28.8581C15.9061 28.6237 16.0377 28.3058 16.0377 27.9742C16.0377 27.8492 16.0002 27.7492 15.9627 27.6367L15.9877 27.6242L15.2502 25.4617L16.7877 24.2367C17.3752 24.2617 18.6377 24.3617 19.2502 24.3992C22.6627 27.4617 19.4377 28.6617 19.4377 28.6617L15.1127 29.9867L14.9002 30.1617C14.772 30.2803 14.6718 30.426 14.6069 30.5882C14.542 30.7503 14.5141 30.9249 14.5252 31.0992L14.5502 32.4367L22.5877 31.8117C23.0627 31.8242 23.5127 31.6492 23.8627 31.3117L29.6252 25.5617C30.2877 24.8867 30.3127 23.6242 29.6252 22.9117Z"
      fill="#7E00FD"
    />
  </svg>
);

export const WorkExperiencesIcon = () => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="24" cy="24" r="24" fill="#9C8AC1" fillOpacity="0.16" />
    <path
      d="M32 18H28V16C28 14.89 27.11 14 26 14H22C20.89 14 20 14.89 20 16V18H16C14.89 18 14.01 18.89 14.01 20L14 31C14 32.11 14.89 33 16 33H32C33.11 33 34 32.11 34 31V20C34 18.89 33.11 18 32 18ZM26 18H22V16H26V18Z"
      fill="#7E00FD"
    />
  </svg>
);

export const EyeIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 10C9.10457 10 10 9.10457 10 8C10 6.89543 9.10457 6 8 6C6.89543 6 6 6.89543 6 8C6 9.10457 6.89543 10 8 10Z"
      fill="white"
    />
    <path
      d="M15.4698 7.83C14.8817 6.30882 13.8608 4.99331 12.5332 4.04604C11.2056 3.09878 9.62953 2.56129 7.99979 2.5C6.37005 2.56129 4.79398 3.09878 3.46639 4.04604C2.1388 4.99331 1.11787 6.30882 0.529787 7.83C0.490071 7.93985 0.490071 8.06015 0.529787 8.17C1.11787 9.69118 2.1388 11.0067 3.46639 11.954C4.79398 12.9012 6.37005 13.4387 7.99979 13.5C9.62953 13.4387 11.2056 12.9012 12.5332 11.954C13.8608 11.0067 14.8817 9.69118 15.4698 8.17C15.5095 8.06015 15.5095 7.93985 15.4698 7.83ZM7.99979 11.25C7.357 11.25 6.72864 11.0594 6.19418 10.7023C5.65973 10.3452 5.24316 9.83758 4.99718 9.24372C4.75119 8.64986 4.68683 7.99639 4.81224 7.36596C4.93764 6.73552 5.24717 6.15642 5.70169 5.7019C6.15621 5.24738 6.73531 4.93785 7.36574 4.81245C7.99618 4.68705 8.64965 4.75141 9.24351 4.99739C9.83737 5.24338 10.3449 5.65994 10.7021 6.1944C11.0592 6.72886 11.2498 7.35721 11.2498 8C11.2485 8.86155 10.9056 9.68743 10.2964 10.2966C9.68722 10.9058 8.86134 11.2487 7.99979 11.25Z"
      fill="white"
    />
  </svg>
);

export const DesignerRoleIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.25 6.75H3.75C3.33579 6.75 3 7.08579 3 7.5V19.5C3 19.9142 3.33579 20.25 3.75 20.25H20.25C20.6642 20.25 21 19.9142 21 19.5V7.5C21 7.08579 20.6642 6.75 20.25 6.75Z"
      stroke="#080F6C"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.75 6.75V5.25C15.75 4.85218 15.592 4.47064 15.3107 4.18934C15.0294 3.90804 14.6478 3.75 14.25 3.75H9.75C9.35218 3.75 8.97064 3.90804 8.68934 4.18934C8.40804 4.47064 8.25 4.85218 8.25 5.25V6.75"
      stroke="#080F6C"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.0001 11.8418C18.2648 13.4243 15.1595 14.2553 11.9994 14.2503C8.83977 14.2553 5.73503 13.4246 3 11.8426"
      stroke="#080F6C"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.875 11.25H13.125"
      stroke="#080F6C"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SalaryIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 6.75V8.25"
      stroke="#080F6C"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 15.75V17.25"
      stroke="#080F6C"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
      stroke="#080F6C"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.75 15.75H13.125C13.6223 15.75 14.0992 15.5525 14.4508 15.2008C14.8025 14.8492 15 14.3723 15 13.875C15 13.3777 14.8025 12.9008 14.4508 12.5492C14.0992 12.1975 13.6223 12 13.125 12H10.875C10.3777 12 9.90081 11.8025 9.54917 11.4508C9.19754 11.0992 9 10.6223 9 10.125C9 9.62772 9.19754 9.15081 9.54917 8.79917C9.90081 8.44754 10.3777 8.25 10.875 8.25H14.25"
      stroke="#080F6C"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const EducationIcon = () => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="24" cy="24" r="24" fill="#9C8AC1" fillOpacity="0.16" />
    <g clipPath="url(#clip0_5222_8284)">
      <path
        d="M17.33 22L24 26L34 20L24 14L14 20H24V22H17.33ZM14 22V30L16 27.78V23.2L14 22ZM24 34L19 31L17 29.8V23.8L24 28L31 23.8V29.8L24 34Z"
        fill="#7E00FD"
      />
    </g>
    <defs>
      <clipPath id="clip0_5222_8284">
        <rect
          width="20"
          height="20"
          fill="white"
          transform="translate(14 14)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const WorkExperiencesFbIcon = () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g opacity="0.35">
      <rect width="40" height="40" rx="20" fill="#292E73" fillOpacity="0.12" />
      <rect
        x="0.25"
        y="0.25"
        width="39.5"
        height="39.5"
        rx="19.75"
        stroke="url(#paint0_linear_5377_3870)"
        strokeOpacity="0.16"
        strokeWidth="0.5"
      />
    </g>
    <rect
      x="6"
      y="6"
      width="28"
      height="28"
      rx="14"
      fill="url(#WorkExperiencesFbIcon)"
    />
    <defs>
      <pattern
        id="WorkExperiencesFbIcon"
        patternContentUnits="objectBoundingBox"
        width="1"
        height="1"
      >
        <use xlinkHref="#image0_5377_3870" transform="scale(0.0078125)" />
      </pattern>
      <linearGradient
        id="paint0_linear_5377_3870"
        x1="20"
        y1="0"
        x2="20"
        y2="40"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#9C8AC1" />
        <stop offset="1" stopColor="#9C8AC1" stopOpacity="0" />
      </linearGradient>
      <image
        id="image0_5377_3870"
        width="128"
        height="128"
        xlinkHref="data:image/png;base64,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"
      />
    </defs>
  </svg>
);

export const EditIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <rect width="16" height="16" fill="url(#EditIcon)" />
    <defs>
      <pattern
        id="EditIcon"
        patternContentUnits="objectBoundingBox"
        width="1"
        height="1"
      >
        <use xlinkHref="#image0_5377_3866" transform="scale(0.0111111)" />
      </pattern>
      <image
        id="image0_5377_3866"
        width="90"
        height="90"
        xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAABmJLR0QA/wD/AP+gvaeTAAADyElEQVR4nO3cv2vWQByA8efyVkEEFVQUHZylCK7iIioIrk4qrk4OgmIdfN+mraCCgoMugpPQoQ5OToqjgziJ/gMKgj9AOwnW5ByaF6O+b3uX3OXN5b4PFNr0cnn5NORN8paAJEmSJEmSJElSS1OTfgFtKEUf1OSXNBwFdgKfgecJye0U9dbFNqKHHpBdAm4BvRG//gVcnKd3v+52kroThNyALAVuMxoZYAq41ye7Vndb0e7RBfKs6XgN/QV616tuL0poW+RhdbCjg66KPKwqdlTQdZGHVcGOBtoV8jBb7CigXSOXumB66hf16Z2D7vbR0yYDo4Cep5cCcx6mnkrIL5sMjAIa/GFrOGYyLhpo8Ia9y2RQVNDgBfuzyaDooMEttoIXJuM6Az0gS4vTOKMcYWeK5I7JwE5Al86TZ5vE1nAlRb0xGRv8BcuYi5Fb8/SuWswxA9y03HQ6T8/4jxQ09DpXfD6xrZAhYGjDy2of2NbIECi05b0Ll9iVkCFA6Io3iFxgV0aGwKBr3oWrg10LGQKCdnSrc644pbPZJjbrjCsIaMf3k632bFe1HtrTTfvGsVsN7fGTEWgYu7XQnpGHNYbdSuiGkIc1gt066IaRh3nHbtXduwkhA/zwvYHW7NETRK59MWJSK6C7jgwtgI4BGSYMHQsyTBA6JmSYEHRsyDAB6BiRoWHoWJGhQeiYkaEh6NiRoQFoQV7NK7Qg/8kbtCD/nRdoQf4/59CCPDqn0II8PmfQgrx2TqAFef1qQwuyWeOeU2HUefSGzahlRbbE6pNa9gNb3Ly0NZsLCRkcvxn20YcU+UuXc47I6v/n2pLTT8E/wWtWH4/jqyCRwTH0A9QKsOxyzlJpqMjg5/86fEAH9cY3Kh/Q3x3PF9wb36g8QKtvDicL+nBRzjm0BlfQwR8uyjmHTtDvHUzTicNFOefQivxpzSmCPYVbK6sLlj76gCI/tR5EysqRnOSkgr05apsi3wZqE7C1+No+ZtVOIoMl9CzZDQ1XqQnSR08XV5Dly/XOIoPVoUMrDaeLH6yeIvBvC6h3wMPSok4jgwV0CoeBfaVFtbA1+lXxbeeRwQJak58dsXh2QGb7+AUAFPoLHTpPXi+jY/R59Ibd5B+BHWOGWO+VKXpjivpps07IGe3Re8hOMB4ZKuzZMSGDIXSOOmMwbKbqYSSGTI/Rxw3HCfaYpgzHrRiM+aDgSU7yuM4L6mqm0I+AmRHLvypYykkWF+AlKO3wtXUqI+iEZJCTA5wr1nmWoBc/0ntWfKoiSZIkSZIkSZIkhdpv/6JnjD4F4CEAAAAASUVORK5CYII="
      />
    </defs>
  </svg>
);

export const PlusIcon = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <rect width="18" height="18" fill="url(#patternPlusIcon)" />
      <defs>
        <pattern
          id="patternPlusIcon"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use xlinkHref="#image0_8235_13378" transform="scale(0.0111111)" />
        </pattern>
        <image
          id="image0_8235_13378"
          width="90"
          height="90"
          xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAABmJLR0QA/wD/AP+gvaeTAAAFg0lEQVR4nO2dW4hWVRTHf8tLGlpO4YNOEmqkL5GlQQ9pkfYaaBftor2VFIJIpK+9CyFSUI8RlJUGEWRoVnaBIK2mekhJrciy1NQu5Jgz/x72p5R96j5n73P2+c7sH3wMfJy99jp/zqyzZ+2110Amk8lkMplMJpPJNBRL7cC5SBoNzAWuB2YDs4CZwATgis5PgD+BY52f+4E9wF5gAPjMzIbq9fzCNEJoSdOAe4BFwK3A5YEmTwDvAzuAzWZ2MNBe7yLpUkkrJG2XNKTqOC1pm6Tlksanvu/akDRR0mpJBysU93z8IulJSZNS61AZksZKekLS0QQCn8tRSY9LGptal6hIWiDpy7TaduVrSXek1icYSeMlPSNpOK2eF2RY0kZJ46rUorJVh6TpwCbg5qrmiMynwDIz+6YK45UILffruIXwZVrdnADuMrN3YhseFdugpCXAG/SeyACTgK2SlsU2HFVoSY8Am4FeXq9eArwo6eGYRqOFDkmLcSKPjmUzMcPA/Wb2SgxjUYSWtBB4E6j0zZ2AU8CdZrYt1FCw0JKuBXbRmzHZhxPAPDPbF2IkKEZ31p6baK/I4F6QL4eus0Nfhk/hUpptZx6wPsRA6dAhaQGwM8RGjyHgdjPbWWZwKZEkjQF245LzI4mvgLlm9nfRgWVDxxrqF/kUsBbo73zWdb6rk+uAVbXMJOkypUl1ru3iy7oEfhyWNLGobmWe6MeAK0uMC+WFLt89X7sXMBlYWXRQoRgttxW0H5hadKJQzKyrr5JUty/AIWCmmf3lO6DoE72UBCI3kCnAkiIDigq9ouD1baaQFt6hQ9JVwHckSho1LHSASzpd7VvKUOSJvpf2ZOZiMIoC4aOI0IuK+9J6Fvpe6BU65Mq0jgB9ZT0KpYGhA+A4MNmn/Mz3iZ5LQpEbTB9wg8+FvkLPKe9L6/FKRfgKPSvAkbbjpY2v0LMDHGk7Xtr4Cj09wJG2M8PnIl+hY21VnU11WkHOZ7CEndgp1niVqZKOREox/i/VmQrFS7Ee9pnPdx09iCssCaXfzH6KYCcYSVOAGL4MmtlFC4ail4RdhCbtL9aaTvAV+vdI8zUp+xfLl1jagKQDkeLZoFxs7I/mXPF76e/4MBjpnvb7zOsbowdIvOPd0FwHwOdmduPFLvINHd8GOtNmDvhc5Cv0ngBH2o6XNlnocKIK/UWAI23HS5uc+A8jbuK/Y+iDUK9ayLu+h/uL/GW4o6QzbcZbkyLlBv3A9+RygzMMAdPM7JDPxd5PtJn9CEQ/f9fDbPcVGYonlboVGo5UCmlRpshxHy55XisNCx3VFjma2UlgQ1GvYtAtESVXppaC9UVEhnL56GeBX0uMC6VbWjNF2vUI8FwtM8k1FambsylWxU91FmF1Gc1CDgvtYuQV1tR7WMjMTuMOzaTOBdeJgFVlRIaAPUMz+xB4uuz4HmRj2TOGELhZKnds9yPcydI28wkw38xK14LEOHR/De5wZ1tbnB3HxWWvnZTzEVxuYO7U/2LgZKitBnIKWBoqMkSq6zCz94D7cImWtjAMLDez7TGMRSugMbPXgUdxDvY6Q8BKM3s1lsHolUNyLX9eonf7Kg0CD1mkFj9nqKod20LgNXrvBXkcWNIJhVGppPbOXN+4OcDHVdiviN3ATVWIXDmSxsm1o2x6y8wNkmJUy6ZF0nxJA2n17MqApFtS6xMVSWMkrZHrd5Gaw3I9rMek1qUyJE3o3OQPCQT+Wa5Rd5u7mv0XuZbHD0p6S649fFWclrRV0gNK2Hq+ERX4kqYCd+POm9+G++8UIRzDdTB7G9hSZLe6Khoh9L+RKz+bgzv6O6vzmYE7GdYHnOln9Adu3fsbrnR2L67gcAAY8K0gymQymUwmk8lkMpkRzz//IPVlsYOmegAAAABJRU5ErkJggg=="
        />
      </defs>
    </svg>
  );
};

export const InviteFriendsIcon = () => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="24" cy="24" r="24" fill="#9C8AC1" fillOpacity="0.16" />
      <g clipPath="url(#clip0_5209_3259)">
        <path
          d="M29 15C29.7652 15 30.5015 15.2923 31.0583 15.8173C31.615 16.3422 31.9501 17.0601 31.995 17.824L32 18V22.35L32.594 22.086C33.208 21.813 33.916 22.236 33.994 22.884L34 23V31C34.0002 31.5046 33.8096 31.9906 33.4665 32.3605C33.1234 32.7305 32.6532 32.9572 32.15 32.995L32 33H16C15.4954 33.0002 15.0094 32.8096 14.6395 32.4665C14.2695 32.1234 14.0428 31.6532 14.005 31.15L14 31V23C14 22.328 14.675 21.853 15.297 22.045L15.407 22.086L16 22.35V18C16 17.2348 16.2923 16.4985 16.8173 15.9417C17.3422 15.385 18.0601 15.0499 18.824 15.005L19 15H29ZM29 17H19C18.7348 17 18.4804 17.1054 18.2929 17.2929C18.1054 17.4804 18 17.7348 18 18V23.239L24 25.906L30 23.239V18C30 17.7348 29.8946 17.4804 29.7071 17.2929C29.5196 17.1054 29.2652 17 29 17ZM24 20C24.2549 20.0003 24.5 20.0979 24.6854 20.2728C24.8707 20.4478 24.9822 20.687 24.9972 20.9414C25.0121 21.1958 24.9293 21.4464 24.7657 21.6418C24.6021 21.8373 24.3701 21.9629 24.117 21.993L24 22H22C21.7451 21.9997 21.5 21.9021 21.3146 21.7272C21.1293 21.5522 21.0178 21.313 21.0028 21.0586C20.9879 20.8042 21.0707 20.5536 21.2343 20.3582C21.3979 20.1627 21.6299 20.0371 21.883 20.007L22 20H24Z"
          fill="#7E00FD"
        />
      </g>
      <defs>
        <clipPath id="clip0_5209_3259">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(12 12)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const CopyIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.2507 17.2501V3.75H6.75"
      stroke="#7E00FD"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.2505 6.75H3.75V20.25H17.2505V6.75Z"
      stroke="#7E00FD"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

